import axios, { AxiosResponse } from "axios";
import {
  IUserFormValues,
  IUser,
  IUserResetPassword,
  IUserChangePassword,
  IUserAdmin,
  IUsers,
  IChangeState,
} from "../models/user";
import data from "./config.json";
import {
  ISupplier,
  ITributaryInformation,
  ITestSetStatus,
  IIntegration,
  IEmailConfig,
  ITestSetDocuments,
} from "../models/company";
import { IResolution, ISyncResolution } from "../models/resolution";
import {
  IDocumentFilterResponse,
  IAcquirersAutocomplete,
  IDocumentTrace,
  IDocumentList,
  ISendInvoiceResult,
  IResendMailForm,
} from "../models/trackDocument";
import {
  IPayrollFilterResponse,
  IEmployeesAutocomplete,
  IPayrollTrace,
  IPayrollList,
  IResendPayrollMailForm,
  IPayrollDetail,
} from "../models/trackPayroll";
import { IGraphicData } from "../models/dashboard";


const apiSecurity = data.find((dat) => dat.name === "Security")?.path;
const apiGeneral = data.find((dat) => dat.name === "General")?.path;
const apiReport = data.find((dat) => dat.name === "Report")?.path;
const apiTestSet = data.find((dat) => dat.name === "TestSet")?.path;


//variables aux para el manejo de tokens
let auxToken: string;
//bandera token
let bToken = false;

axios.interceptors.request.use(
  (config) => {
    if (!bToken) {
      const token = window.localStorage.getItem("jwt");
      if (token) config.headers.Authorization = `Bearer ${token}`;
      return config;
    } else {
      config.headers.Authorization = `Bearer ${auxToken}`;
      bToken = false;
      return config;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

const responseBody = (response: AxiosResponse) => response.data;

const requests = {
  get: (url: string) => axios.get(url).then(responseBody),
  getWithBody: (url: string, body: {}) =>
    axios.get(url, { params: body }).then(responseBody),
  post: (url: string, body: {}) => axios.post(url, body).then(responseBody),
  put: (url: string, body: {}) => axios.put(url, body).then(responseBody),
  patch: (url: string, body: {}) => axios.patch(url, body).then(responseBody),
  del: (url: string) => axios.delete(url).then(responseBody),
  postForm: (url: string, file: Blob) => {
    let formData = new FormData();
    formData.append("File", file);
    return axios
      .post(url, formData, {
        headers: { "Content-type": "multipart/form-data" },
      })
      .then(responseBody);
  },
};

const User = {
  resetPassword: (
    resetPassword: IUserResetPassword,
    token: string
  ): Promise<boolean> => {
    bToken = true;
    auxToken = token;
    return axios.post(
      `${apiSecurity}/Authentication/ResetPassword`,
      resetPassword,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
  },

  login: (user: IUserFormValues): Promise<IUser> =>
    requests.post(`${apiSecurity}/Authentication/Authenticate`, user),
  changePassword: (paaswordCange: IUserChangePassword): Promise<boolean> =>
    requests.post(
      `${apiSecurity}/Authentication/ChangePassword`,
      paaswordCange
    ),
  sendReset: (username: string): Promise<string> =>
    requests.get(`${apiSecurity}/Authentication/SendReset/${username}`),
  editUser: (id: string, userEdit: any): Promise<IUser> =>
    requests.patch(`${apiSecurity}/User/${id}`, userEdit),
  relogUser: (): Promise<IUser> => requests.get(`${apiSecurity}/User/UserInfo`),
};

const ListOfValours = {
  //lista responsabilidades fiscales
  getTaxLevelCode: (): Promise<any[]> =>
    requests.get(`${apiReport}/ListOfValues/TaxLevelCodes`),
  //lista regimen fiscal
  getTaxLevelName: (): Promise<any[]> =>
    requests.get(`${apiReport}/ListOfValues/TaxLevelNames`),
  //lista tributo
  getPartyTax: (): Promise<any[]> =>
    requests.get(`${apiReport}/ListOfValues/PartyTaxes`),

  getDocumentTypes: (): Promise<any[]> =>
    requests.get(`${apiReport}/ListOfValues/DocumentTypes`),
  getIdType: (): Promise<any[]> =>
    requests.get(`${apiReport}/ListOfValues/AllIDType`),
  getCities: (stateCode: string): Promise<any[]> =>
    requests.get(`${apiReport}/ListOfValues/SubStates/${stateCode}`),
  getCountrySubentities: (): Promise<any[]> =>
    requests.get(`${apiReport}/ListOfValues/States`),
  getRejectionConcepts: (): Promise<any[]> =>
    requests.get(`${apiReport}/ListOfValues/RejectionConcepts`),
  getRejectionConceptsByEmail: (token: string): Promise<any> =>{
    bToken = true;
    auxToken = token;
    return axios.get(`${apiReport}/ListOfValues/RejectionConcepts`, {
      headers: { Authorization: `Bearer ${token}` },
    })
  },
};

const Company = {
  updateSupplier: (supplier: any): Promise<ISupplier> =>
    requests.patch(`${apiGeneral}/Supplier/supplier`, supplier),
  updateIntegration: (integration: IIntegration): Promise<ISupplier> =>
    requests.patch(
      `${apiGeneral}/Supplier/supplierIntegrationInfo`,
      integration
    ),
  updateEmailConfig: (emailConfig: IEmailConfig): Promise<ISupplier> =>
    requests.patch(`${apiGeneral}/Supplier/supplierEmailConfig`, emailConfig),
  updateSupplierBillingInfo: (
    supplierBilling: ITributaryInformation
  ): Promise<ISupplier> =>
    requests.patch(
      `${apiGeneral}/Supplier/supplierBillingInfo`,
      supplierBilling
    ),
  getSupplier: (): Promise<ISupplier> => requests.get(`${apiGeneral}/Supplier`),
  uploadLogo: (file: Blob): Promise<ISupplier> =>
    requests.postForm(`${apiGeneral}/Supplier/logo`, file),
  updateSupplierSw: (supplierSw: any): Promise<ISupplier> =>
    requests.patch(
      `${apiGeneral}/Supplier/updateSoftwareInfoAsync`,
      supplierSw
    ),
  updateTestSet: (testSetId: string): Promise<ISupplier> =>
    requests.patch(`${apiGeneral}/Supplier/updateTestSetIdAsync`, testSetId),
  getTestSetStatus: (): Promise<ITestSetStatus> =>
    requests.get(`${apiGeneral}/Supplier/getTestSetStatus`),
  tesSetStatusApproved: (): Promise<ISupplier> =>
    requests.patch(`${apiGeneral}/Supplier/tesSetStatusApproved`, {}),
  getTestSet: (): Promise<ITestSetDocuments> =>
    requests.get(`${apiGeneral}/Supplier/TestSet`),
  addTestSet: (body): Promise<ITestSetDocuments> =>
    requests.post(`${apiTestSet}/TestSet/LoadTestSet`, body),
  sendProdTestSet: (documentId): Promise<ITestSetDocuments> =>
    requests.post(`${apiTestSet}/TestSet/ApproveByDocumentType/${documentId}`, {}),
  rebootTestSet: (body): Promise<ITestSetDocuments> =>
    requests.post(`${apiTestSet}/TestSet/Reboot`, body),
};

const UsersAdmin = {
  getUsers: (): Promise<IUsers[]> => requests.get(`${apiSecurity}/User`),
  editUser: (id: string, userEdit: any): Promise<any> =>
    requests.patch(`${apiSecurity}/User/admin/${id}`, userEdit),
  createUser: (user: IUserAdmin): Promise<any> =>
    requests.post(`${apiSecurity}/User`, user),
  getCheckRegister: (username: string): Promise<boolean> =>
    requests.get(`${apiSecurity}/User/CheckRegister/${username}`),
  changeUserState: (userChange: IChangeState): Promise<boolean> =>
    requests.patch(`${apiSecurity}/User/ChangeState`, userChange),
};

const Resolutions = {
  getResolutions: (): Promise<IResolution[]> =>
    requests.get(`${apiGeneral}/Resolution`),
  syncResolutions: (): Promise<ISyncResolution> =>
    requests.post(`${apiGeneral}/Resolution`, {}),
};

const Certificates = {
  getCertificates: (): Promise<any[]> =>
    requests.get(`${apiGeneral}/Certificate`),
  postCertificate: (certificateForm: any): Promise<any> =>
    requests.post(`${apiGeneral}/Certificate`, certificateForm),
  delCertificate: (id: string): Promise<boolean> =>
    requests.del(`${apiGeneral}/Certificate/${id}`),
};

const TrackDocuments = {
  getTrackDocuments: (filter: any): Promise<IDocumentFilterResponse> =>
    requests.getWithBody(`${apiReport}/DocumentReport/filter`, filter),
  getAcquirersAutocomplete: (
    search: string
  ): Promise<IAcquirersAutocomplete[]> =>
    requests.get(`${apiReport}/DocumentReport/acquirers/${search}`),
  getDocumentNumberAutocomplete: (search: string): Promise<any> =>
    requests.get(`${apiReport}/DocumentReport/documentNumber/${search}`),
  getDianNumberAutocomplete: (search: string): Promise<any> =>
    requests.get(`${apiReport}/DocumentReport/dianNumber/${search}`),
  resendMail: (
    data: IResendMailForm,
    document: IDocumentList
  ): Promise<ISendInvoiceResult> =>
    requests.patch(
      `${apiGeneral}/GeneralDocument/SendInvoiceToContact/${document.id}/${data.mail}/${data.contact}`,
      {}
    ),
    resendBulkMail: (
      data: IResendMailForm,
      documentIds: string[],
    ): Promise<ISendInvoiceResult> => {
      const email = data.mail || undefined;
      const subject = data.subject || undefined;
      const ccEmail = data.ccEmail || undefined;

      return requests.patch(
        `${apiGeneral}/GeneralDocument/SendMultipleEmails`,
        {
          documentIds,
          email,
          subject,
          ccEmail
        }
      )},
  };

const Invoice = {
  getUBLById: (id: string): Promise<any> =>
    requests.get(`${apiReport}/DocumentReport/GetUBLById/${id}`),
  getUBLB64ById: (id: string): Promise<any> =>
    requests.get(`${apiReport}/DocumentReport/GetBase64UBLById/${id}`),
  getAttachDocumentB64ByErpDocumentId: (erpDocumentId: string): Promise<any> =>
    requests.get(
      `${apiReport}/DocumentReport/GetBase64AttachmentByErpDocumentId/${erpDocumentId}`
    ),
  getPDFById: (id: string): Promise<any> =>
    requests.get(`${apiReport}/DocumentReport/GetBase64PDFById/${id}`),
  acceptDocument: (id: string): Promise<IDocumentList> =>
    requests.patch(`${apiGeneral}/GeneralDocument/AcceptDocument/${id}`, {}),
  rejectDocument: (id: string, reason: string): Promise<IDocumentList> =>
    requests.patch(
      `${apiGeneral}/GeneralDocument/RejectDocument/${id}/${reason}`,
      {}
    ),
  getDocumentTrace: (id: string): Promise<IDocumentTrace[]> =>
    requests.get(`${apiReport}/DocumentReport/GetDocTraceByDocId/${id}`),
  getDocumentNotifications: (id: string): Promise<IDocumentTrace[]> =>
    requests.get(`${apiReport}/DocumentReport/GetNotificationsByDocId/${id}`),
  getDocumentById: (id: string): Promise<any> =>
    requests.get(`${apiReport}/DocumentReport/GetDocumentById/${id}`),
};

const Guest = {
  acceptDocumentByEmail: (id: string, token: string): Promise<any> =>
    axios.patch(
      `${apiGeneral}/Guest/AcceptDocument/${id}`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    ),
  rejectDocumentByEmail: (
    id: string,
    reason: string,
    token: string
  ): Promise<any> =>
    axios.patch(
      `${apiGeneral}/Guest/RejectDocument/${id}/${reason}`,
      {},
      { headers: { Authorization: `Bearer ${token}` } }
    ),
  getDocumentInfo: (id: string, token: string): Promise<any> =>
    axios.get(`${apiGeneral}/Guest/DocumentInfo/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    }),
};

const Dashboard = {
  getCurrentWeekData: (isValid: boolean): Promise<IGraphicData[]> =>
    requests.get(`${apiReport}/DocumentReport/GetCurrentWeekData/${isValid}`),
  getLastWeekData: (isValid: boolean): Promise<IGraphicData[]> =>
    requests.get(`${apiReport}/DocumentReport/GetLastWeekData/${isValid}`),
  getCurrentMonthData: (isValid: boolean): Promise<IGraphicData[]> =>
    requests.get(`${apiReport}/DocumentReport/GetCurrentMonthData/${isValid}`),
  getLastMonthData: (isValid: boolean): Promise<IGraphicData[]> =>
    requests.get(`${apiReport}/DocumentReport/GetLastMonthData/${isValid}`),
  getCurrentDayData: (isValid: boolean): Promise<IGraphicData[]> =>
    requests.get(`${apiReport}/DocumentReport/GetCurrentDayData/${isValid}`),
  getCountAllSuccessDocuments: (): Promise<number> =>
    requests.get(`${apiReport}/DocumentReport/CountAllSuccessDocuments`),
  getFirstYearOfBilling: (): Promise<number> =>
    requests.get(`${apiReport}/DocumentReport/FirstYearOfBilling`),
  getGraphDataYearSuccessDocuments: (year: number): Promise<any> =>
    requests.get(
      `${apiReport}/DocumentReport/GraphDataYearSuccessDocuments/${year}`
    ),
};

const DashboardPayroll = {
  getCurrentWeekData: (isValid: boolean): Promise<IGraphicData[]> =>
    requests.get(`${apiReport}/PayrollReport/GetCurrentWeekData/${isValid}`),
  getLastWeekData: (isValid: boolean): Promise<IGraphicData[]> =>
    requests.get(`${apiReport}/PayrollReport/GetLastWeekData/${isValid}`),
  getCurrentMonthData: (isValid: boolean): Promise<IGraphicData[]> =>
    requests.get(`${apiReport}/PayrollReport/GetCurrentMonthData/${isValid}`),
  getLastMonthData: (isValid: boolean): Promise<IGraphicData[]> =>
    requests.get(`${apiReport}/PayrollReport/GetLastMonthData/${isValid}`),
  getCurrentDayData: (isValid: boolean): Promise<IGraphicData[]> =>
    requests.get(`${apiReport}/PayrollReport/GetCurrentDayData/${isValid}`),
  getCountAllSuccessPayrolls: (): Promise<number> =>
    requests.get(`${apiReport}/PayrollReport/CountAllSuccessPayrolls`),
  getFirstYearOfBilling: (): Promise<number> =>
    requests.get(`${apiReport}/PayrollReport/FirstYearOfBilling`),
  getGraphDataYearSuccessPayrolls: (year: number): Promise<any> =>
    requests.get(
      `${apiReport}/PayrollReport/GraphDataYearSuccessPayrolls/${year}`
    ),
};

const TrackPayrolls = {
  getTrackPayrolls: (filter: any): Promise<IPayrollFilterResponse> =>
    requests.getWithBody(`${apiReport}/PayrollReport/filter`, filter),
  getEmployeesAutocomplete: (
    search: string
  ): Promise<IEmployeesAutocomplete[]> =>
    requests.get(`${apiReport}/PayrollReport/Employees/${search}`),
  getDocumentNumberAutocomplete: (search: string): Promise<any> =>
    requests.get(`${apiReport}/PayrollReport/DocumentNumber/${search}`),
  resendMail: (
    data: IResendPayrollMailForm,
    payroll: IPayrollList
  ): Promise<ISendInvoiceResult> =>
    requests.patch(
      `${apiGeneral}/GeneralPayroll/SendPayrollToContact/${payroll.id}/${data.mail}/${data.contact}`,
      {}
    ),
  resendBulkMail: (
    data: IResendPayrollMailForm,
    payrollIds: string[],
  ): Promise<ISendInvoiceResult> => {
    const email = data.mail || undefined;
    const subject = data.subject || undefined;
    const ccEmail = data.ccEmail || undefined;

    return requests.patch(
      `${apiGeneral}/GeneralPayroll/SendMultipleEmails`,
      {
        payrollIds,
        email,
        subject,
        ccEmail
      }
    )},
};

const Payroll = {
  getUBLById: (id: string): Promise<any> =>
    requests.get(`${apiReport}/PayrollReport/GetUBLById/${id}`),
  getPDFById: (id: string): Promise<any> =>
    requests.get(`${apiReport}/PayrollReport/GetPDFById/${id}`),
  getBase64PDFById: (id: string): Promise<string> =>
    requests.get(`${apiReport}/PayrollReport/GetBase64PDFById/${id}`),
  getBase64UBLById: (id: string): Promise<string> =>
    requests.get(`${apiReport}/PayrollReport/GetBase64UBLById/${id}`),
  getPayrollTrace: (id: string): Promise<IPayrollTrace[]> =>
    requests.get(`${apiReport}/PayrollReport/GetDocTraceByDocId/${id}`),
  getPayrollNotifications: (id: string): Promise<IPayrollTrace[]> =>
    requests.get(`${apiReport}/PayrollReport/GetNotificationsByDocId/${id}`),
  getPayrollById: (id: string): Promise<IPayrollDetail> =>
    requests.get(`${apiReport}/PayrollReport/GetPayrollById/${id}`),
};

export default {
  User,
  ListOfValours,
  Company,
  UsersAdmin,
  Resolutions,
  Certificates,
  TrackDocuments,
  TrackPayrolls,
  Invoice,
  Payroll,
  Dashboard,
  DashboardPayroll,
  Guest,
};
